import { Pipe, PipeTransform } from '@angular/core';
import { formatCurrency } from '@angular/common';
import { ConfigService } from 'src/app/services/config.service';


@Pipe({
  name: 'currencyFormatter',
  pure: false,
})
export class CurrencyFormatterPipe implements PipeTransform {

  constructor(private configs: ConfigService) {

  }

  transform(value: any, with_code: boolean = true): unknown {
    const currencyParam = this.configs.currencyData;
    let locale = "en", currency = this.configs.SYSTEM_CONFIG['currency'], currencyCode = this.configs.SYSTEM_CONFIG['currency'] || currencyParam.strCode,
        digitsInfo = '1.' + currencyParam.intFractionsCount + "-" + currencyParam.intFractionsCount;
    const amount = formatCurrency(Number.parseFloat(value.toString()), locale, currency, currencyCode, digitsInfo).replace(/[^0-9\.,-]+/g, "");

    if(!currencyParam.bCodeAppendedEnd)
     return (with_code ? currencyParam.strCode.concat(currencyParam.bAddCodeValueSeparator ? currencyParam.strCodeValueSeparator : ' '): "") + amount;
    return amount + (with_code ? (currencyParam.bAddCodeValueSeparator ? currencyParam.strCodeValueSeparator : ' ').concat(currencyParam.strCode) : "");
  }

}
